import { createMuiTheme } from '@material-ui/core/styles';
import { AlertClassKey } from '@material-ui/lab/Alert';

declare module '@material-ui/core/styles/overrides' {
    export interface ComponentNameToClassKey {
        MuiAlert: AlertClassKey;
    }
}

const theme = createMuiTheme({

    palette: {
        type: 'dark',

        background: {
            paper: '#00152E',
            default: '#00152E'
        },

        primary: {
            light: '#5174d5',
            main: '#0049a3',
            dark: '#000',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#DBDBDB',
        },

    },
    typography: {
        fontFamily: "'Lato', sans-serif;",
        fontSize: 18,
        button: {
            textTransform: "none",
            fontWeight: "normal",
        },
        h1: {
            fontSize: 36,
        },
        h2:{
            fontSize:60,
            fontWeight:600,
        },
        h3:{
            fontSize:16,
            
        },
        h4:{
            fontSize:18,
            fontWeight:600
        }

    },
    overrides: {
        MuiTypography: {
            body1: {
                fontSize: 18,
            }
        }
        ,
        MuiInputBase:{
            input:{
                padding:"12px"
            },
          
        },
        MuiOutlinedInput: {
            root: {
                backgroundColor: '#ffffff38',
                color: '#fff',
                height: '40px',
                borderRadius: '6px',
                border: 'none',
            },
            notchedOutline: {
                border: 'none'
            }
        },
        MuiIconButton:{
            root:{
                // borderRadius:"3px",
                // backgroundColor:"#02489D",
                padding:"7.5px",
            }
        },
     
    }
});


export default theme;